
<div class="lv-meta-links fds">
  <p class="desc mb-0">
    <icon glyph="related-object" aria-hidden="true" class="mr-2"></icon>
    {{totalCount}} record{{ totalCount === 1 ? '' : 's'}}
  </p>
  <p v-if="showCreateRelatedEntry" class="mb-0">
    <button @click="$emit('click-create-related-entry')" type="button" class="btn-link desc mb-0">
      Create Record
    </button>
  </p>
  <p v-if="showViewAll" class="mb-0">
    <button @click="$emit('click-view-all')" type="button" class="btn-link desc mb-0">
      View All
      <icon glyph="open-file" class="ml-2" tag="small" aria-hidden="true"></icon>
    </button>
  </p>
</div>
